import { FormController } from '@form-ts/core';
import { SyncMode } from 'src/modules/common/types/SyncMode';
import { UserManagementFormData } from 'src/modules/common/types/UserManagementFormData';
import { FormError } from 'src/modules/form/types/FormError';
import { OrganizationUser } from 'src/modules/users/types/OrganizationUser';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const USER_SAVE = createActions<
OrganizationUser,
OrganizationUser,
OrganizationUser
>('USER_SAVE');

export const USER_ADD = createActions<
FormController<UserManagementFormData, FormError>,
OrganizationUser
>('USER_ADD');

export const USER_DELETE = createActions<
ReadonlyArray<OrganizationUser>,
void,
ReadonlyArray<OrganizationUser>
>('USER_DELETE');

export const USER_SYNC_PERFORM = createActions<SyncMode, void>('USER_SYNC_PERFORM');
export const USER_SYNC_RESET = createTrigger<void>('USER_SYNC_RESET');
